<template>
  <div id="main" class="productCenter">
    <topNav></topNav>
    <div class="inner" v-if="showNav.Big == 'DA' && showNav.small == 'a1'">
      <div class="demobox bigNav">
        <img
          src="../../common/images/productCenter/ztcl/763.png"
          class="bigNav-img"
          alt=""
        />
      </div>
      <div class="demobox bigNav2" id="banner">
          <img src="../../common/images/productCenter/ztcl/26832.png"  alt="">
      </div>
      <div class="demobox bigNav3" id="banner">
          <img src="../../common/images/productCenter/ztcl/26830.png"  alt="">
      </div>
      <!-- <div class="demobox banner2 bannera1" id="banner2">
          <img src="../../common/images/productCenter/ztcl/26830.png" alt="">
      </div> -->
    </div>
    <Bottoms></Bottoms>
  </div>
</template>

<script>
import topNav from "../sub/topNav";
import Bottoms from "../sub/Bottoms";

export default {
  name: "ztcl",
  components: { topNav, Bottoms },
  data() {
    return {
      showNav: {
        Big: "DA",
        small: "a1",
      },
      videoDAsrc: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zb.mp4",
      videoDBsrc: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/jy.mp4",
      palyDA: true,
      palyDB: true,
      playingA: false,
      playingB: false,
    };
  },
  mounted() {
  },
  methods: {
      wenzi(item){ //锚链接跳转
        let banner = document.getElementById('banner');
        let banner2 = document.getElementById('banner2');
        let items = document.querySelector('.hexing').children;
        // console.log(items[0]);
        if(item==0){
            document.getElementById('banner').scrollIntoView();
            items[0].classList.add('xlk');
            items[1].classList.remove('xlk');
        }else{
            items[1].classList.add('xlk');
            items[0].classList.remove('xlk');
            document.getElementById('banner2').scrollIntoView();
        }
        
        // banner.href = 
      }
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  text-align: center;
}
.demobox {
  width: 100%;
  /* height: 600px; */
  overflow: hidden;
}
.boxin {
  width: 1226px;
  /* overflow: hidden; */
  margin: 0 auto;
}
.bigNav {
  height: 496px;
}
.bigNav2{
    height: 689px;
}
.bigNav2{
    height: 696px;
}
.bigNav3{
    height: 696px;
}
.bigNav .bigNav-img {
  width: 100%;
  height: 496px;
}
.bigNavbox {
  width: 1226px;
  height: 88px;
  border-bottom: 1px solid #dcdcdc;
  display: flex;
  justify-content: space-between;
  padding: 0 108px;
  box-sizing: border-box;
  z-index: 5;
}
.NavD {
  width: 400px;
  height: 100%;
  z-index: 10;
  box-sizing: border-box;
  cursor: pointer;
}
.NavD span {
  display: block;
  width: 136px;
  height: 48px;
  margin: 0 auto;
  margin-top: 30px;
  font-size: 34px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #888;
  opacity: 1;
}
.NavD span:hover {
  color: #e7413b;
}
.isBnav {
  border-bottom: 2px solid #e7413b;
}
.isBnav span {
  color: #e7413b;
}
/* .banner {
  height: 5037px;
}
.banner2{
    height: 1436px;
} */
.wenzi {
  position: absolute;
  right: 22.5%;
  bottom: 38%;
}

.tougu{
  position: absolute;
  right: 61.3%;
  bottom: 29%;
}
.tougu a{
  color: #DFB283 !important;
  border-bottom: 1px solid #DFB283 !important;
}
.shift{
  right: 27.5% !important;
  bottom: 38% !important;
}
.wenzi a {
  color: #228efb;
  font-size: 18px;
  font-weight: 600;
  margin-right: 50px;
  border-bottom: 1px solid #228efb;
  padding-bottom: 4px;
}
.wenzi a:hover {
  cursor: pointer;
}
/* .bannera1 {
  background: url("../common/images/productCenter/A1/26818.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.bannera2 {
  background: url("../common/images/productCenter/A2/bannerback.png") no-repeat;
  background-size: 100% 100%;
}
.bannera3 {
  background: url("../common/images/productCenter/A3/bannerback.png") no-repeat;
  background-size: 100% 100%;
}
.bannerb1 {
  background: url("../common/images/productCenter/B1/bannerback.png") no-repeat;
  background-size: 100% 100%;
}
.bannerb2 {
  background: url("../common/images/productCenter/B2/bannerback.png") no-repeat;
  background-size: 100% 100%;
} */
.banmain {
  height: 460px;
}
.smallNav {
  position: relative;
}
.wenzi2 {
  position: absolute;
  right: 58.9%;
  bottom: 28%;
}
.wenzi2 a {
  color: #ff4b4f;
  font-size: 18px;
  font-weight: 600;
  margin-right: 50px;
  border-bottom: 1px solid #ff4b4f;
  padding-bottom: 4px;
}
.wenzi2 a:hover {
  cursor: pointer;
}
.smallNavbox {
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
  padding-bottom: 47px;
}
.Navd {
  width: 374px;
  height: 82px;
  background-color: #f5f5f5;
  border-radius: 6px;
  text-align: center;
  line-height: 82px;
  font-size: 34px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #888888;
  cursor: pointer;
}
.Navd:hover {
  color: #e7413b;
}
.isSnav {
  /* background: url("../common/images/productCenter/A1/isSnav.png") no-repeat; */
  background-size: 100% 100%;
  color: #fff;
}
.isSnav:hover {
  color: #fff;
}
.all .title {
  width: 100%;
  margin-top: 60px;
}
.all .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.all .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.all .title-b {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}
.hexing{
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-evenly;
    line-height: 80px;
}
.hexing span{
    font-family: PingFang SC-Regular;
    color: #333333;
    font-size: 26px;
    /* border-bottom: 1px solid #DE161E; */
    font-weight: 400;
    height: 80px;
    width: 160px;
}
.hexing span:hover{
    cursor: pointer;
}
.xlk{
    border-bottom: 5px solid #DE161E;
    padding-bottom: 4px;
    
}
</style>



// WEBPACK FOOTER //
// src/components/productCenter/ztcl.vue